<template>

    <div id="theater" class="section">
      <div class="theater_box">
        <div class="theater_text">
  
          <div class="logo_wrap">
  
            <div class="theater_logo"><h1>Theater</h1></div>
  
            <div class="theater_inside_box">
  
              <div class="content_box">
                <a href="https://tollywood.jp/" class="theater1_content" target="_blank">
                  <div class="theater1_photo">https://tollywood.jp/</div>
                  <div class="theater1_profile"></div>
                </a>
              </div>
            
              <div class="content_box">
                <a href="https://kyoto.uplink.co.jp/movie/2023/14641" class="theater2_content" target="_blank">
                  <div class="theater2_photo">https://kyoto.uplink.co.jp/movie/2023/14641</div>
                  <div class="theater2_profile"></div>
                </a>
              </div>
            </div> <!-- inside -->
  
            <div class="theater_inside_box">
  
  <div class="content_box2">
    <a href="https://theater-donut.com/" class="theater3_content" target="_blank">
      <div class="theater3_photo">https://theater-donut.com/</div>
      <div class="theater3_profile"></div>
    </a>
  </div>


</div> <!-- inside -->

<br><br>

            </div> <!-- logo wrap-->
  
        </div>
      </div>
    </div>

  </template>
  
  <style>
  
  #theater{

    /* border: 2px dashed rgb(7, 217, 108);  */
    position: relative;
    display: flex;
    font-family: 'Shippori Mincho', sans-serif;
    display: flex;
    height: 100vh;
    width:auto;
    margin-bottom: 4vh;

    justify-content: center;
  }
  
  .theater_box{
    /* border: 2px solid rgb(24, 5, 194);  */
    position: relative;
    display: flex;
    text-align: left;
    padding: 0px;
    padding-top: 12vh;
    width:auto;
    height:auto;
    justify-content: center;
    /* margin-left: 15vw; */
    /* margin-right: 15vw; */
  
  
  }
  
  .theater_text{
    /* border: 2px dashed rgb(62, 5, 194);  */
    position:relative;
    top:0%;
    padding-right: 0%;
    padding-left: 0vw;
    width:auto;
    height: auto;
    ;
  }
  
  .logo_wrap{
    display: block;
    /* border: 2px dashed rgb(5, 194, 21);  */
    width:auto;
    height: auto;
  
  }
  
  .theater_logo{
    /* border: 2px solid rgb(194, 5, 74);  */
    position:relative;
    top:0%;
    padding-right: 0%;
    padding-left: 0;
    width:auto;
    
    height: auto;
    display: flex;
    justify-content:flex-start;
  }
  
  .theater_logo h1{
    /* border: 2px solid rgb(5, 194, 43);  */
    top:0%;
    
    line-height: 1;
    letter-spacing: 0px; 
    /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3); */
    font-weight: bolder;
    font-size:calc(32px);
    padding-left: 0vw;
  }
  
  
  .theater_inside_box{
    /* border: 4px solid rgb(5, 159, 194);  */
    width: auto;
    height: auto;
    display: flex;
    flex-wrap: wrap;
    margin-top: 1vh;
    /* align-items: center; */
    justify-content: center;
  }


  .content_box{
    /* border: 3px dashed rgb(191, 5, 194);  */
    padding-left: 0;
    padding-right: 0;
    padding-top: 10px;
    margin: 0;
    width: auto;
    
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .content_box2{
    /* border: 3px dashed rgb(5, 194, 55);  */
    padding-left: 0;
    padding-right: 0;
    padding-top: 10px;
    margin: 0;
    width: auto;
    margin-right: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .theater1_content{
    /* border: 4px dashed rgb(8, 5, 194);  */
    align-items: top;
    margin-top: 0vw;
    margin-left:0px;
    margin-right:30px;
    margin-bottom: 3vw;
    padding-right: 0vw; 
    width: auto;
    height: auto;
  
  }
  
  .theater2_content{
    /* border: 2px dashed rgb(194, 5, 74);  */
    align-items: top;
    margin-top: 0vw;
    margin-left:30px;
    margin-right:0px;
    margin-bottom: 3vw;
    padding-left: 0vw; 
    width: auto;
    height: auto;
  }
  
  
  .theater1_photo{
    /* border: 1px solid rgb(13, 0, 255); */
    background-image: url('../assets/Theater_tollywood.svg');
    background-size:contain;
    background-repeat: no-repeat;
    background-position: center;
    height:18vw;
    width:18vw;
    max-width: 320px;  
    max-height: 320px;
  
    min-width: 200px;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items:end;
    font-family: 'Zen Kaku Gothic New', sans-serif;
    font-size: calc(12px); 
  }
  
  .theater2_photo{
    /* border: 1px solid rgb(13, 0, 255); */
    background-image: url('../assets/Theater_kyoto.svg');
    background-size:contain;
    background-repeat: no-repeat;
    background-position: center;
    height:18vw;
    width:18vw;
    max-width: 320px;  
    max-height: 320px;
  
    min-width: 200px;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items:end;
    font-family: 'Zen Kaku Gothic New', sans-serif;
    font-size: calc(12px); 
  }
  
  .theater3_photo{
    /* border: 1px solid rgb(13, 0, 255); */
    background-image: url('../assets/Theater_okinawa.svg');
    background-size:contain;
    background-repeat: no-repeat;
    background-position: center;
    height:18vw;
    width:18vw;
    max-width: 320px;  
    max-height: 320px;
  
    min-width: 200px;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items:end;
    font-family: 'Zen Kaku Gothic New', sans-serif;
    font-size: calc(12px); 
  }
  




  .theater1_profile{
    /* border: 3px solid rgb(126, 131, 4);  */
    letter-spacing: 0.2px;
    padding-left: 0;
    padding-right: 0;
    font-weight: lighter; 
    font-size: calc(14px); 
    line-height: normal;
    width: 18vw;
    height: auto;
    max-width: 320px; 
    min-width: 200px;
    margin-top: 0;
    padding-top: 0;
    text-align:center;
    
  }
  
  .theater2_profile{
    /* border: 1px solid rgb(126, 131, 4);  */
    letter-spacing: 0.2px;
    padding-left: 0;
    padding-right: 0;
    font-size: calc(14px); 
    line-height: normal;
    width: 18vw;
    height: auto;
    max-width: 320px; 
    min-width: 200px;
    text-align: justify;
  }
  

  .theater3_profile{
    /* border: 1px solid rgb(126, 131, 4);  */
    letter-spacing: 0.2px;
    padding-left: 0;
    padding-right: 0;
    font-size: calc(14px); 
    line-height: normal;
    width: 18vw;
    height: auto;
    max-width: 320px; 
    min-width: 200px;
    text-align: justify;
  }


  
  
  .theater1_profile  h2,h3{
    /* border: 1px solid rgb(34, 0, 255);  */
    font-family: 'Zen Kaku Gothic New', sans-serif;
  
    line-height: 0.3;
    padding-left: 0px;
    padding-bottom: 6px;
    margin-top: 24px;
    margin-bottom: 12px;
    width: auto;
  }
  
  .theater2_profile  h2,h3{
    /* border: 1px solid rgb(34, 0, 255);  */
    font-family: 'Zen Kaku Gothic New', sans-serif;
    line-height: 0.3;
    padding-left: 0px;
    padding-bottom: 6px;
    margin-top: 24px;
    margin-bottom: 12px;
    width: auto;
  }
  
  .theater3_profile  h2,h3{
    /* border: 1px solid rgb(34, 0, 255);  */
    font-family: 'Zen Kaku Gothic New', sans-serif;
    line-height: 0.3;
    padding-left: 0px;
    padding-bottom: 6px;
    margin-top: 24px;
    margin-bottom: 12px;
    width: auto;
  }
  
  .align-left{
    padding-left: 0px;
    margin-top: 0;
    padding-top: 0;
  }
  
  

  
  @media (max-width: 680px) {
  
    .theater_text{
      width:70vw;
      margin-left: 3vw;
      margin-right: 3vw;
    }
  
    .content_box {
      width: auto;
    }

    .content_box2{
    /* border: 3px dashed rgb(5, 194, 55);  */
    padding-left: 0;
    padding-right: 0;
    padding-top: 10px;
    margin: 0;
    width: auto;

    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

    .theater1_content {
      width: auto;
      margin-right:0vw;
    }
  
    .theater2_content {
      width: auto;
      margin-left:0vw;
    }
  
    .theater2_photo{
      width:200px;
      height:200px;
    }
  
    .theater1_photo{
      width:200px;
      height:200px;
  
    }
  
    .theater2_profile{
    /* border: 5px solid rgb(246, 255, 0);  */
    letter-spacing: 0.2px;
    padding-left: 0;
    padding-right: 0;
    font-size: calc(14px); 
    line-height: 1.6;
    width: auto;
    height: auto;
    
  }
  .theater1_profile{
    /* border: 5px solid rgb(246, 255, 0);  */
    letter-spacing: 0.2px;
    padding-left: 0;
    padding-right: 0;
    font-size: calc(14px); 
    line-height: 1.6;
    width: auto;
    height: auto;
    text-align: center;
  }
  
  }
  
  
  
  
  </style>